import { render, staticRenderFns } from "./FinancePnl.vue?vue&type=template&id=48f1b200&scoped=true"
import script from "./FinancePnl.vue?vue&type=script&lang=js"
export * from "./FinancePnl.vue?vue&type=script&lang=js"
import style0 from "./FinancePnl.vue?vue&type=style&index=0&id=48f1b200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1b200",
  null
  
)

export default component.exports